import { useQuery } from '@tanstack/react-query'

import type { Quiz } from '../types/quiz'

import { api } from '@/shared/services/api'

/**
 * Só os quizzes disponíveis chegam aqui: o backend já escopa a listagem por
 * `available_for_user`. Quiz indisponível é OMITIDO — não existe estado
 * "bloqueado" para quiz, ao contrário das missões.
 */
export function useQuizzes() {
  return useQuery({
    queryKey: ['/user/quizzes'],
    queryFn: async () => {
      const { data } = await api.get<{ records: Quiz[] }>('/user/quizzes')
      return data.records
    }
  })
}

export function useQuiz(id: number) {
  return useQuery({
    queryKey: ['/user/quizzes', id],
    queryFn: async () => {
      const { data } = await api.get<{ record: Quiz }>(`/user/quizzes/${id}`)
      return data.record
    },
    enabled: Number.isFinite(id)
  })
}
